import {inboxConstants, sentConstants} from "../../constants";

const initialState = {
  inboxList: {},
  inboxOrgList: {},
  isLoading: false,
  isFailure: false,
  isDelete: false,
  isSubmit: false,
  isSubDoc: false,
  isReceive: false,
  receiverList: [],
  pcrlInfo: {},
  crtfInfo: {}
}

export default function inbox(state = initialState, action) {
  switch (action.type) {
    /***********
     수신함 검색조건 변경
     ************/
    case inboxConstants.SELECT_SEARCH_REQUEST:
      console.log("1");

      return {
        ...state,
        selectInfo: action.payload
      }

    /*********
     수신함 목록 조회
     **********/
    case inboxConstants.INBOX_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.INBOX_SUCCESS:
      return {
        ...state,
        inboxList: action.response.data?.payload,
        isDelete: false,
        isReject: false,
      }
    case inboxConstants.INBOX_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
     수신함 원본 목록 조회
     **********/
    case inboxConstants.INBOX_ORG_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.INBOX_ORG_SUCCESS:
      return {
        ...state,
        inboxOrgList: action.response.data?.payload,
        isDelete: false,
        isReject: false,
      }
    case inboxConstants.INBOX_ORG_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
     증명서 삭제
     **********/
    case inboxConstants.DELETE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.DELETE_SUCCESS:
      return {
        ...state,
        isDelete: true,
      }
    case inboxConstants.DELETE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isDelete: false,
      }

    /***********
     수신함 증명서 상세 선택
     ************/
    case inboxConstants.SELECT_REQUEST:
      return {
        ...state,
        info: action.payload
      }

    /*********
     수신함 증명서 상세 조회
     **********/
    case inboxConstants.DETAIL_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.DETAIL_SUCCESS:
      return {
        ...state,
        inboxInfo: action.response.data?.payload,
        isFailure: false
      }
    case inboxConstants.DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /***********
     증명서 제출 수신자 SELECT 팝업 오픈
     ************/
    case inboxConstants.OPEN_RECEIVER_REQUEST:
      return {
        ...state,
        target: action.payload
      }

    /***********
     증명서 제출 수신자 추가
     ************/
    case inboxConstants.ADD_RECEIVER_REQUEST:
      return {
        ...state,
        receiver: action.payload
      }

    /***********
     증명서 제출 첨부문서 row 최신화
     ************/
    case inboxConstants.CHANGE_FILE_REQUEST:
      return {
        ...state,
        fileList: action.payload
      }

    /*********
     최근 보낸 주소 조회
     **********/
    case inboxConstants.SELECT_RECENT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.SELECT_RECENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        receiverList: action.response.data?.payload
      }
    case inboxConstants.SELECT_RECENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
     수신함 증명서제출 전자지갑주소검색
     **********/
    case inboxConstants.WALLET_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.WALLET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        walletList: action.response.data?.payload
      }
    case inboxConstants.WALLET_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
     수신함 증명서제출 전자지갑이름검색
     **********/
    case inboxConstants.WALLET_NAME_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.WALLET_NAME_SUCCESS:
      return {
        ...state,
        isLoading: false,
        walletName: action.response.data?.payload ? action.response.data?.payload : false
      }
    case inboxConstants.WALLET_NAME_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /***********
     증명서 제출 전자지갑 리스트 초기화
     ************/
    case inboxConstants.RESET_RECEIVER:
      return {
        ...state,
        receiverList: [],
        walletList: []
      }

    /*********
     수신함 구매확인서 상세조회
     **********/
    case inboxConstants.PCRL_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.PCRL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pcrlInfo: action.response.data?.payload
      }
    case inboxConstants.PCRL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
     수신함 간접수출실적 상세조회
     **********/
    case inboxConstants.CRTF_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.CRTF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        crtfInfo: action.response.data?.payload
      }
    case inboxConstants.CRTF_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
     증명서 제출
     **********/
    case inboxConstants.SUBMIT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.SUBMIT_SUCCESS:
      return {
        ...state,
        isSubmit: true,
      }
    case inboxConstants.SUBMIT_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    /*********
     증명서 반려
     **********/
    case inboxConstants.REJECT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.REJECT_SUCCESS:
      return {
        ...state,
        isReject: true,
      }
    case inboxConstants.REJECT_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    /***********
     증명서 수신함 히스토리 관리
     ************/
    case inboxConstants.INBOX_HISTORY:
      return {
        ...state,
        history: action.payload
      }

    /*********
     증명서 PDF BASE64STRING 조회
     **********/
    case inboxConstants.PDF_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFailure: false,
      }
    case inboxConstants.PDF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pdfString: action.response.data
      }
    case inboxConstants.PDF_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /***********
     PDF 호출 init 처리
     ************/
    case inboxConstants.INIT_FLAG_REQUEST:
      return {
        ...state,
        pdfString: null
      }

    /***********
     상태관련 state 초기화
     ************/
    case inboxConstants.CLEAR_REQUEST:
      return {
        ...state,
        isFailure: false,
        isDelete: false,
        isSubmit: false,
      }

    /*********
     증명서 첨부파일 다운로드
     **********/
    case inboxConstants.FILE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isFile: true
      }
    case inboxConstants.FILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFile: false
      }

    /***********
   수신함 PDF 발급요청
     ************/
    case inboxConstants.SUB_SENT_DOC_PDF_REQUEST:
      return {
        ...state,
      }
    case inboxConstants.SUB_SENT_DOC_PDF_SUCCESS:
      return {
        ...state,
        isFailure: false,
        isSubDoc: true,
      }
    case inboxConstants.SUB_SENT_DOC_PDF_FAILURE:
      return {
        ...state,
        isFailure: true,
      }

    /*********
   증명서 수취완료
     **********/
    case inboxConstants.RECEIVE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case inboxConstants.RECEIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isReceive: true,
      }
    case inboxConstants.RECEIVE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isReceive: false,
      }

    default:
      return state
  }
}
